module.exports = __webpack_public_path__ + "img/main_menu_login.ed7e359f.svg";